import LoginRouter from '@root/login/src/components/login-router';
import PropTypes from '@root/vendor/prop-types';
import environment from '@root/core/src/utils/environment';
import { withRouter } from '@root/core/src/components/route';

function LoginEntry({
  module,
  location,
  passProps,
  domain = environment.quoteAppDomain,
  isModuleInPath = true,
}) {
  return (
    <div>
      <LoginRouter
        domain={domain}
        isModuleInPath={isModuleInPath}
        location={location}
        module={module}
        passProps={passProps}
      />
    </div>
  );
}

LoginEntry.propTypes = {
  domain: PropTypes.string,
  isModuleInPath: PropTypes.bool,
  location: PropTypes.object.isRequired,
  module: PropTypes.string.isRequired,
  passProps: PropTypes.object.isRequired,
};

export default withRouter(LoginEntry);
